import axios from 'axios'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_ADMIN_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
})

export default {
  setAccessToken (accessToken) {
    httpClient.defaults.headers = { Authorization: `Bearer ${accessToken}` }
  },
  async getRules (subscriptionId) {
    try {
      const { data } = await httpClient.get(`/${subscriptionId}/sentiment-rules`)
      return data
    } catch (e) {
      console.error(`Can't fetch rules. Error: ${e.message}`)
      throw new Error('Cannot fetch rules from API')
    }
  },
  async addRule (subscriptionId, phrase, value, stemmed, lang, projects) {
    const { data } = await httpClient.post(`/${subscriptionId}/new-sentiment-rule`, { phrase, value, stemmed, lang, projects })
    return data
  },
  async updateRule (subscriptionId, id, value, projects) {
    try {
      const { data } = await httpClient.post(`/${subscriptionId}/sentiment-rule/${id}/update`, { value, projects })
      return data
    } catch (e) {
      console.error(`Can't update new rule. Error: ${e.message}`)
      throw new Error('Cannot  update new rule')
    }
  },
  async deleteRule (subscriptionId, id) {
    try {
      const { data } = await httpClient.post(`/${subscriptionId}/sentiment-rule/${id}/delete`)
      return data
    } catch (e) {
      console.error(`Can't delete rule. Error: ${e.message}`)
      throw new Error('Cannot delete rule')
    }
  }
}
